import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import { FAILED_TO_SYNC_STATUS } from '../constants.ts';
import { LastSyncErrorDateTime } from './LastSyncErrorDateTime.tsx';

const mapStatusToIndicatorStatus = (status: string | null | undefined): string | undefined => {
  if (!status) return undefined;

  // Map EXPIRED to deal-expired for proper StatusIndicator rendering
  if (status.toUpperCase() === 'EXPIRED') {
    return 'deal-expired';
  }

  return status;
};

type SyncStatusFieldProps = {
  label: string;
  loading: boolean;
  status: string | undefined;
  statusLabel: string | undefined;
  tooltip: string | undefined;
  lastErrorDatetime?: string;
};

export const SyncStatusField = ({
  label,
  loading,
  status,
  statusLabel,
  tooltip,
  lastErrorDatetime,
}: SyncStatusFieldProps) => {
  const hasValue = status || statusLabel;

  const renderContent = () => {
    if (loading) return <Loader size={20} noPadding />;

    if (hasValue) {
      return <StatusIndicator status={mapStatusToIndicatorStatus(status)} label={statusLabel} tooltip={tooltip} />;
    }

    return <ValuePlaceholder />;
  };

  return (
    <Grid size={RIGHT_COLUMN_WIDTH + 4}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
        }}
      >
        {label}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {renderContent()}

        {status === FAILED_TO_SYNC_STATUS && lastErrorDatetime && (
          <LastSyncErrorDateTime errorDatetime={lastErrorDatetime} />
        )}
      </Box>
    </Grid>
  );
};
